import { useLoader } from '@react-three/fiber';
import { Texture, TextureLoader } from 'three';
import { PLYLoader } from 'three-stdlib';

export const usePlyLoader = (url: string, accessToken: string) => {
  const object = useLoader(PLYLoader, url, (loader) => {
    loader.setRequestHeader({
      Authorization: 'Bearer ' + accessToken,
    });
  });

  return object;
};

export const useTextureLoader = (url: string, accessToken: string) => {
  const texture = useLoader(TextureLoader, url, (loader) => {
    // Override the default load function to handle blob conversion
    const originalLoad = loader.load;

    loader.load = function (url, onLoad, onProgress, onError) {
      const texture = new Texture();
      fetch(url, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
        },
      })
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => {
          const blob = new Blob([arrayBuffer]);
          const blobUrl = URL.createObjectURL(blob);
          return originalLoad.call(
            this,
            blobUrl,
            (loadedTexture) => {
              URL.revokeObjectURL(blobUrl);
              Object.assign(texture, loadedTexture);
              onLoad?.(texture);
            },
            onProgress,
            (error) => {
              URL.revokeObjectURL(blobUrl);
              onError?.(error);
            }
          );
        })
        .catch(onError);
      return texture;
    };
  });

  return texture;
};
